import * as React from "react";
import { forwardRef } from "react";
const SvgX = (props, ref) => /* @__PURE__ */ React.createElement("svg", { height: "current", viewBox: "0 0 14 14", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M1 13L13 1M1 1L13 13", stroke: "current", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgX);
export default ForwardRef;
